import { useEffect, useState } from "react";

/** Default pause after typing before server list filters hit the API. */
export const LIST_FILTER_DEBOUNCE_MS = 400;

/**
 * Returns `value` after it has been stable for `delayMs`.
 * Use for text filters so each keystroke does not trigger a fetch.
 */
export function useDebouncedValue(value, delayMs = LIST_FILTER_DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (delayMs <= 0) {
      setDebounced(value);
      return undefined;
    }
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
